export default __webpack_public_path__ + "static/media/heroBg.1c5a8eee.png";